module.exports = __webpack_public_path__ + "img/bell.706e2de6.svg";